var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', {
    attrs: {
      "title": "미리보기",
      "fullscreen": "",
      "persistent": "",
      "width": "1200"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(bind) {
        return [_vm._t("activator", null, null, bind)];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('recruitment-view-card', _vm._b({
    staticClass: "py-60",
    attrs: {
      "isPreview": ""
    }
  }, 'recruitment-view-card', {
    recruitment: Object.assign({}, _vm.recruitment, {
      company: _vm.$store.state.user
    })
  }, false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }